const channels = state => state.channels
const isLoadingChannels = state => state.isLoadingChannels

const messages = state => state.messages
const isLoadingMessages = state => state.isLoadingMessages
const errorMessages = state => state.errorMessages

const message = state => state.message
const isLoadingSendMessages = state => state.isLoadingSendMessages
const errorMessage = state => state.errorMessage

const subscribers = state => state.subscribers
const isLoadingFetchSubscribers = state => state.isLoadingFetchSubscribers
const errorFetchSubscribers = state => state.errorFetchSubscribers

const isLoadingPostSubscribers = state => state.isLoadingPostSubscribers
const errorPostSubscribers = state => state.errorPostSubscribers

const messageEmail = state => state.messageEmail
const isLoadingMessageEmail = state => state.isLoadingMessageEmail
const errorMessageEmail = state => state.errorMessageEmail

export default {
  isLoadingChannels,
  channels,
  messages,
  isLoadingMessages,
  errorMessages,
  message,
  isLoadingSendMessages,
  errorMessage,
  subscribers,
  isLoadingFetchSubscribers,
  errorFetchSubscribers,
  isLoadingPostSubscribers,
  errorPostSubscribers,
  messageEmail,
  isLoadingMessageEmail,
  errorMessageEmail,
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/getters.js